'use client';

import { createToggleStore } from '@/lib/helpers/createToggleStore';

export const useNavDrawer = createToggleStore();
